import React from 'react';
import PropTypes from 'prop-types';
const filter = require('lodash/filter');
const indexOf = require('lodash/indexOf');

const Globals = require('../../../../app/globals');
import ProjectListHeader from './ProjectListHeader';
import ProjectListItem from './ProjectListItem';
import FolderListItem from './FolderListItem';
import FolderListItemGoUp from './FolderListItemGoUp';
import DashboardListItemEmpty from './DashboardListItemEmpty';
const SortUtil = require('../../util/SortUtil');
const LocalStorage = require('../../util/localStorage');
import ProjectActivityList from './ProjectActivityList';
import ProjectShortCourseList from './ProjectShortCourseList';
import WithChannelActivities from '../DataHOCs/WithChannelActivities';
import WithChannelShortCourses from '../DataHOCs/WithChannelShortCourses';

const propTypes = {
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    projects: PropTypes.array,
    folders: PropTypes.array,
    foldersFlat: PropTypes.object,
    sortObj: SortUtil.SortObjPropType.isRequired,
    sortFunc: PropTypes.func,
    filterActive: PropTypes.bool.isRequired,
    activityMatchesFilter: PropTypes.func.isRequired,
    shortCourseMatchesFilter: PropTypes.func.isRequired,
    projectMatchesFilter: PropTypes.func.isRequired,
    folderMatchesFilter: PropTypes.func.isRequired,
    activityStoreState: PropTypes.shape({ initialized: PropTypes.bool, activities: PropTypes.object }).isRequired,
    shortCourseStoreState: PropTypes.shape({ initialized: PropTypes.bool, activities: PropTypes.object }).isRequired,
    goToFolderView: PropTypes.func.isRequired,
    viewFolder: PropTypes.object,
    parentFolder: PropTypes.object,
    grandParentFolder: PropTypes.object,
    contentType: PropTypes.oneOf([Globals.content_type.ACTIVITY, Globals.content_type.COURSE]).isRequired,
};

const defaultProps = {
    projects: [],
    folders: [],
    foldersFlat: {},
    sortFunc: null,
    viewFolder: null,
    parentFolder: null,
    grandParentFolder: null,
};

class ProjectList extends React.Component {
    constructor(props) {
        super(props);

        this.reconileAndGetExpandedFolders = this.reconileAndGetExpandedFolders.bind(this);
        this.reconileAndGetExpandedProjects = this.reconileAndGetExpandedProjects.bind(this);

        this.state = {
            expandedProjects: this.reconileAndGetExpandedProjects(props.channelId, props.projects),
            expandedFolders: this.reconileAndGetExpandedFolders(props.channelId, props.foldersFlat),
        };

        this.toggleExpandProject = this.toggleExpandProject.bind(this);
        this.toggleExpandFolder = this.toggleExpandFolder.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.channelId !== nextProps.channelId) {
            this.setState({
                expandedProjects: this.reconileAndGetExpandedProjects(nextProps.channelId, nextProps.projects),
                expandedFolders: this.reconileAndGetExpandedFolders(nextProps.channelId, nextProps.foldersFlat),
            });
        }
    }

    reconileAndGetExpandedFolders(channelId, foldersFlat) {
        const storedExpandedFolders = LocalStorage.getViewSettingPropForViewSubset("channel", channelId, "expanded_folders") || [];
        const reconciledFolderIds = [];
        let changed = false;
        storedExpandedFolders.forEach((folderId) => {
            if (!foldersFlat[folderId]) {
                changed = true;
                return;
            }

            reconciledFolderIds.push(folderId);
        });

        if (changed) {
            LocalStorage.setViewSettingPropForViewSubset('channel', channelId, 'expanded_folders', reconciledFolderIds);
        }

        return reconciledFolderIds;
    }

    reconileAndGetExpandedProjects(channelId, projects) {
        const storedExpandedProjects = LocalStorage.getViewSettingPropForViewSubset("channel", channelId, "expanded_projects") || [];
        const reconciledProjectIds = [];
        let changed = false;
        storedExpandedProjects.forEach((projectId) => {
            if (!projects.find(p => p.id === projectId)) {
                changed = true;
                return;
            }

            reconciledProjectIds.push(projectId);
        });

        if (changed) {
            LocalStorage.setViewSettingPropForViewSubset('channel', channelId, 'expanded_projects', reconciledProjectIds);
        }

        return reconciledProjectIds;
    }

    toggleExpandProject(projectId) {
        const foundIndex = this.state.expandedProjects.indexOf(projectId);
        let updatedArr;
        if (foundIndex >= 0) {
            updatedArr = this.state.expandedProjects.filter(pId => pId !== projectId);
        }
        else {
            updatedArr = this.state.expandedProjects.concat(projectId);
        }

        LocalStorage.setViewSettingPropForViewSubset('channel', this.props.channelId, 'expanded_projects', updatedArr);
        this.setState({ expandedProjects: updatedArr });
    }

    toggleExpandFolder(folderId) {
        const foundIndex = this.state.expandedFolders.indexOf(folderId);
        let updatedArr;
        if (foundIndex >= 0) {
            updatedArr = this.state.expandedFolders.filter(fId => fId !== folderId);
        }
        else {
            updatedArr = this.state.expandedFolders.concat(folderId);
        }

        LocalStorage.setViewSettingPropForViewSubset('channel', this.props.channelId, 'expanded_folders', updatedArr);
        this.setState({ expandedFolders: updatedArr });
    }

    render() {
        let projectsRendered = 0;
        let folderNodesRendered = 0;
        let rootProjects = [];
        let folderProjects = {};
        this.props.projects.forEach((proj) => {
            if (
                (!this.props.viewFolder && !proj.folder_id)
                || (!!this.props.viewFolder && this.props.viewFolder.id === proj.folder_id)
            ) {
                rootProjects.push(proj);
            }
            else {
                if (!folderProjects[proj.folder_id]) folderProjects[proj.folder_id] = [];
                folderProjects[proj.folder_id].push(proj);
            }
        });

        return (
            <div className="mzl-cs-content tile-dash-floating projectList">
                <ProjectListHeader
                    className="padding-tb-md font-weight-bold"
                    sortObj={this.props.sortObj}
                    sortFunc={this.props.sortFunc}
                    contentType={this.props.contentType}
                />
                <ul>
                    {!!this.props.viewFolder &&
                        <FolderListItemGoUp
                            key="up"
                            goUp={this.props.goToFolderView.bind(null, this.props.viewFolder.parent_id)}
                            parentName={this.props.parentFolder ? this.props.parentFolder.name : ''}
                        />

                    }
                    {this.props.folders.map((folder) => {
                        let elems;
                        if (folder.content_type === Globals.content_type.ACTIVITY) {
                            elems = FolderProjActList({
                                folder: folder,
                                folderProjects: folderProjects,
                                activities: this.props.activityStoreState.activities,
                                filterActive: this.props.filterActive,
                                folderMatchesFilter: this.props.folderMatchesFilter,
                                projectMatchesFilter: this.props.projectMatchesFilter,
                                activityMatchesFilter: this.props.activityMatchesFilter,
                                expandedProjects: this.state.expandedProjects,
                                expandedFolders: this.state.expandedFolders,
                                toggleExpandProject: this.toggleExpandProject,
                                toggleExpandFolder: this.toggleExpandFolder,
                                sortObj: this.props.sortObj,
                                depth: 0,
                                goToFolderView: this.props.goToFolderView,
                            });
                        }
                        else if (folder.content_type === Globals.content_type.COURSE) {
                            elems = FolderProjScList({
                                folder: folder,
                                folderProjects: folderProjects,
                                shortCourses: this.props.shortCourseStoreState.shortCourses,
                                filterActive: this.props.filterActive,
                                folderMatchesFilter: this.props.folderMatchesFilter,
                                projectMatchesFilter: this.props.projectMatchesFilter,
                                shortCourseMatchesFilter: this.props.shortCourseMatchesFilter,
                                expandedProjects: this.state.expandedProjects,
                                expandedFolders: this.state.expandedFolders,
                                toggleExpandProject: this.toggleExpandProject,
                                toggleExpandFolder: this.toggleExpandFolder,
                                sortObj: this.props.sortObj,
                                depth: 0,
                                goToFolderView: this.props.goToFolderView,
                            });
                        }

                        folderNodesRendered += elems.length;
                        return elems;
                    })}
                    {rootProjects.map((project) => {
                        let elems = [];
                        if (project.content_type === Globals.content_type.ACTIVITY) {
                            const activities = this.props.activityStoreState.activities[project.id] || []; // possibly undefined (after creating new project)
                            const filteredActivities = filter(activities, act => this.props.activityMatchesFilter(act));

                            elems = ProjectActList({
                                project: project,
                                activities: activities,
                                filteredActivities: filteredActivities,
                                filterActive: this.props.filterActive,
                                projectMatchesFilter: this.props.filterActive && this.props.projectMatchesFilter(project),
                                projHasActMatchingFilter: this.props.filterActive && filteredActivities.length > 0,
                                activityMatchesFilter: this.props.activityMatchesFilter,
                                shortCourseMatchesFilter: this.props.shortCourseMatchesFilter,
                                projectIsExpanded: this.state.expandedProjects.indexOf(project.id) >= 0,
                                toggleExpandProject: this.toggleExpandProject.bind(this, project.id),
                                sortObj: this.props.sortObj,
                                depth: 0,
                            });
                        }
                        else if (project.content_type === Globals.content_type.COURSE) {
                            const shortCourses = !!this.props.shortCourseStoreState.shortCourses[project.id] ? Object.values(this.props.shortCourseStoreState.shortCourses[project.id]) : [];
                            const filteredShortCourses = filter(shortCourses, sc => this.props.shortCourseMatchesFilter(sc));

                            elems = ProjectScList({
                                project: project,
                                shortCourses: shortCourses,
                                filteredShortCourses: filteredShortCourses,
                                filterActive: this.props.filterActive,
                                projectMatchesFilter: this.props.filterActive && this.props.projectMatchesFilter(project),
                                projHasScMatchingFilter: this.props.filterActive && filteredShortCourses.length > 0,
                                shortCourseMatchesFilter: this.props.shortCourseMatchesFilter,
                                projectIsExpanded: this.state.expandedProjects.indexOf(project.id) >= 0,
                                toggleExpandProject: this.toggleExpandProject.bind(this, project.id),
                                sortObj: this.props.sortObj,
                                depth: 0,
                            });
                        }

                        if (elems.length) ++projectsRendered;
                        return elems;
                    })}
                    {this.props.filterActive && projectsRendered === 0 && folderNodesRendered === 0 &&
                        <DashboardListItemEmpty message="No results for filter" />
                    }
                </ul>
            </div>
        );
    }
}

ProjectList.propTypes = propTypes;
ProjectList.defaultProps = defaultProps;

export default WithChannelActivities(WithChannelShortCourses(ProjectList));


/*ProjectActList.propTypes = {
    project: PropTypes.object.isRequired,
    activities: PropTypes.array.isRequired,
    filteredActivities: PropTypes.array.isRequired,
    filterActive: PropTypes.bool.isRequired,
    projectMatchesFilter: PropTypes.bool.isRequired,
    projHasActMatchingFilter: PropTypes.bool.isRequired,
    activityMatchesFilter: PropTypes.func.isRequired,
    projectIsExpanded: PropTypes.bool.isRequired,
    toggleExpandProject: PropTypes.func.isRequired,
    sortObj: PropTypes.object.isRequired,
}*/

function ProjectActList(props) {
    let elems = [];
    const renderProjectListItem = !props.filterActive || props.projectMatchesFilter || props.projHasActMatchingFilter;
    if (renderProjectListItem) {
        elems.push(
            <ProjectListItem
                className={props.projectMatchesFilter ? 'highlight' : ''}
                key={props.project.id}
                project={props.project}
                expanded={props.projectIsExpanded || props.projHasActMatchingFilter}
                onToggleExpansion={props.toggleExpandProject}
                depth={props.depth}
                contentType={Globals.content_type.ACTIVITY}
            />
        );
    }

    const showActivityList = renderProjectListItem && (props.projectIsExpanded || (props.filterActive && props.projHasActMatchingFilter));
    const actsToShow = (props.filterActive && !props.projectMatchesFilter) ? props.filteredActivities : props.activities;
    if (actsToShow.length > 0) {
        elems.push(
            <li key={`acts-${props.project.id}`}>
                <ProjectActivityList
                    className={showActivityList ? '' : 'activityList__hidden'}
                    activityMatchesFilter={props.activityMatchesFilter}
                    filterActive={props.filterActive}
                    activities={actsToShow}
                    projectId={props.project.id}
                    sortObj={props.sortObj}
                    depth={props.depth+1}
                />
            </li>
        );
    }

    return elems;
}


/*ProjectScList.propTypes = {
    project: PropTypes.object.isRequired,
    shortCourses: PropTypes.object.isRequired,
    filteredShortCourses: PropTypes.array.isRequired,
    filterActive: PropTypes.bool.isRequired,
    projectMatchesFilter: PropTypes.bool.isRequired,
    projHasScMatchingFilter: PropTypes.bool.isRequired,
    shortCourseMatchesFilter: PropTypes.func.isRequired,
    projectIsExpanded: PropTypes.bool.isRequired,
    toggleExpandProject: PropTypes.func.isRequired,
    sortObj: PropTypes.object.isRequired,
}*/

function ProjectScList(props) {
    let elems = [];
    const renderProjectListItem = !props.filterActive || props.projectMatchesFilter || props.projHasScMatchingFilter;
    if (renderProjectListItem) {
        elems.push(
            <ProjectListItem
                className={props.projectMatchesFilter ? 'highlight' : ''}
                key={props.project.id}
                project={props.project}
                expanded={props.projectIsExpanded || props.projHasScMatchingFilter}
                onToggleExpansion={props.toggleExpandProject}
                depth={props.depth}
                contentType={Globals.content_type.COURSE}
            />
        );
    }

    const showActivityList = renderProjectListItem && (props.projectIsExpanded || (props.filterActive && props.projHasScMatchingFilter));
    const scsToShow = (props.filterActive && !props.projectMatchesFilter) ? props.filteredShortCourses : props.shortCourses;
    if (scsToShow.length > 0) {
        elems.push(
            <li key={`acts-${props.project.id}`}>
                <ProjectShortCourseList
                    className={showActivityList ? '' : 'activityList__hidden'}
                    shortCourseMatchesFilter={props.shortCourseMatchesFilter}
                    filterActive={props.filterActive}
                    shortCourses={scsToShow}
                    projectId={props.project.id}
                    channelId={props.project.channelId}
                    sortObj={props.sortObj}
                    depth={props.depth+1}
                />
            </li>
        );
    }

    return elems;
}


/*FolderProjActList.propTypes = {
    folder: PropTypes.object.isRequired,
    folderProjects: PropTypes.object.isRequired,
    activities: PropTypes.object.isRequired,
    filterActive: PropTypes.bool.isRequired,
    projectMatchesFilter: PropTypes.func.isRequired,
    activityMatchesFilter: PropTypes.func.isRequired,
    expandedProjects: PropTypes.array.isRequired,
    expandedFolders: PropTypes.array.isRequired,
    toggleExpandProject: PropTypes.func.isRequired,
    sortObj: PropTypes.object.isRequired,
    goToFolderView: PropTypes.func.isRequired
}*/

function FolderProjActList(props) {
    const projsInFolder = props.folderProjects[props.folder.id] || [];
    const filteredProjects = filter(projsInFolder, proj => props.projectMatchesFilter(proj));
    const folderProjectIds = projsInFolder.map(p => p.id);
    let folderActivities = [];
    folderProjectIds.forEach((pId) => {
        folderActivities = folderActivities.concat(props.activities[pId]);
    })
    const filteredActivities = filter(folderActivities, act => props.activityMatchesFilter(act));
    const folderMatchesFilter = props.filterActive && props.folderMatchesFilter(props.folder);
    const folderHasProjectMatchingFilter = props.filterActive && filteredProjects.length > 0;
    const folderHasActMatchingFilter = props.filterActive && filteredActivities.length > 0;
    const folderIsExpanded = props.expandedFolders.indexOf(props.folder.id) >= 0;

    let elems = [];
    let hasRenderedChildFolders = false;
    let hasRenderedChildProjects = false;
    
    const rootElem = (
        <FolderListItem
            className={folderMatchesFilter ? 'highlight' : ''}
            key={props.folder.id}
            folder={props.folder}
            expanded={folderIsExpanded || folderHasProjectMatchingFilter || folderHasActMatchingFilter}
            onToggleExpansion={props.toggleExpandFolder.bind(null, props.folder.id)}
            depth={props.depth}
            goToFolderView={props.goToFolderView}
        />
    );

    let childFolderElems = [];
    let childProjectElems = [];
    if (folderIsExpanded || props.filterActive) {
        let sortedChildFolders = [];
        if (props.folder.children) {
            sortedChildFolders = SortUtil.sortObjectArray(props.folder.children, props.sortObj);
            sortedChildFolders.forEach((childFolder) => {
                childFolderElems = childFolderElems.concat(FolderProjActList({
                    folder: childFolder,
                    folderProjects: props.folderProjects,
                    activities: props.activities,
                    filterActive: props.filterActive,
                    folderMatchesFilter: props.folderMatchesFilter,
                    projectMatchesFilter: props.projectMatchesFilter,
                    activityMatchesFilter:props.activityMatchesFilter,
                    expandedProjects: props.expandedProjects,
                    expandedFolders: props.expandedFolders,
                    toggleExpandProject: props.toggleExpandProject,
                    toggleExpandFolder: props.toggleExpandFolder,
                    sortObj: props.sortObj,
                    depth: props.depth + 1,
                    goToFolderView: props.goToFolderView,
                }))
            });
            if (childFolderElems.length > 0) hasRenderedChildFolders = true;
        }

        if (projsInFolder.length > 0) {
            projsInFolder.forEach((project) => {
                const activities = props.activities[project.id] || [];
                const filteredActivities = filter(activities, act => props.activityMatchesFilter(act));
                childProjectElems = childProjectElems.concat(ProjectActList({
                    project: project,
                    activities: activities,
                    filteredActivities: filteredActivities,
                    filterActive: props.filterActive,
                    projectMatchesFilter: props.filterActive && props.projectMatchesFilter(project),
                    projHasActMatchingFilter: props.filterActive && filteredActivities.length > 0,
                    activityMatchesFilter: props.activityMatchesFilter,
                    projectIsExpanded: props.expandedProjects.indexOf(project.id) >= 0,
                    toggleExpandProject: props.toggleExpandProject.bind(self, project.id),
                    sortObj: props.sortObj,
                    depth: props.depth + 1,
                }));
            });
            if (childProjectElems.length) hasRenderedChildProjects = true;
        }
        
        if (!props.filterActive && !sortedChildFolders.length && !projsInFolder.length) {
            childProjectElems.push(<DashboardListItemEmpty key="empty" />);
        }
    }

    if (
        props.filterActive
        && !folderMatchesFilter
        && !hasRenderedChildFolders
        && !hasRenderedChildProjects
    ) {
        return [];
    }

    return [rootElem].concat(childFolderElems).concat(childProjectElems);
}



/*FolderProjScList.propTypes = {
    folder: PropTypes.object.isRequired,
    folderProjects: PropTypes.object.isRequired,
    shortCourses: PropTypes.object.isRequired,
    filterActive: PropTypes.bool.isRequired,
    projectMatchesFilter: PropTypes.func.isRequired,
    shortCourseMatchesFilter: PropTypes.func.isRequired,
    expandedProjects: PropTypes.array.isRequired,
    expandedFolders: PropTypes.array.isRequired,
    toggleExpandProject: PropTypes.func.isRequired,
    sortObj: PropTypes.object.isRequired,
    goToFolderView: PropTypes.func.isRequired
}*/

function FolderProjScList(props) {
    const projsInFolder = props.folderProjects[props.folder.id] || [];
    const filteredProjects = filter(projsInFolder, proj => props.projectMatchesFilter(proj));
    const folderProjectIds = projsInFolder.map(p => p.id);
    let folderShortCourses = [];
    folderProjectIds.forEach((pId) => {
        if (props.shortCourses[pId]) {
            folderShortCourses = folderShortCourses.concat(props.shortCourses[pId]);
        }
    })
    const filteredShortCourses = filter(folderShortCourses, sc => props.shortCourseMatchesFilter(sc));
    const folderMatchesFilter = props.filterActive && props.folderMatchesFilter(props.folder);
    const folderHasProjectMatchingFilter = props.filterActive && filteredProjects.length > 0;
    const folderHasScMatchingFilter = props.filterActive && filteredShortCourses.length > 0;
    const folderIsExpanded = props.expandedFolders.indexOf(props.folder.id) >= 0;

    let elems = [];
    let hasRenderedChildFolders = false;
    let hasRenderedChildProjects = false;
    
    const rootElem = (
        <FolderListItem
            className={folderMatchesFilter ? 'highlight' : ''}
            key={props.folder.id}
            folder={props.folder}
            expanded={folderIsExpanded || folderHasProjectMatchingFilter || folderHasScMatchingFilter}
            onToggleExpansion={props.toggleExpandFolder.bind(null, props.folder.id)}
            depth={props.depth}
            goToFolderView={props.goToFolderView}
        />
    );

    let childFolderElems = [];
    let childProjectElems = [];
    if (folderIsExpanded || props.filterActive) {
        let sortedChildFolders = [];
        if (props.folder.children) {
            sortedChildFolders = SortUtil.sortObjectArray(props.folder.children, props.sortObj);
            sortedChildFolders.forEach((childFolder) => {
                childFolderElems = childFolderElems.concat(FolderProjScList({
                    folder: childFolder,
                    folderProjects: props.folderProjects,
                    shortCourses: props.shortCourses,
                    filterActive: props.filterActive,
                    folderMatchesFilter: props.folderMatchesFilter,
                    projectMatchesFilter: props.projectMatchesFilter,
                    shortCourseMatchesFilter: props.shortCourseMatchesFilter,
                    expandedProjects: props.expandedProjects,
                    expandedFolders: props.expandedFolders,
                    toggleExpandProject: props.toggleExpandProject,
                    toggleExpandFolder: props.toggleExpandFolder,
                    sortObj: props.sortObj,
                    depth: props.depth + 1,
                    goToFolderView: props.goToFolderView,
                }))
            });
            if (childFolderElems.length > 0) hasRenderedChildFolders = true;
        }

        if (projsInFolder.length > 0) {
            projsInFolder.forEach((project) => {
                const shortCourses = !!props.shortCourses[project.id] ? Object.values(props.shortCourses[project.id]) : [];
                const filteredShortCourses = filter(shortCourses, sc => props.shortCourseMatchesFilter(sc));
                childProjectElems = childProjectElems.concat(ProjectScList({
                    project: project,
                    shortCourses: shortCourses,
                    filteredShortCourses: filteredShortCourses,
                    filterActive: props.filterActive,
                    projectMatchesFilter: props.filterActive && props.projectMatchesFilter(project),
                    projHasScMatchingFilter: props.filterActive && filteredShortCourses.length > 0,
                    shortCourseMatchesFilter: props.shortCourseMatchesFilter,
                    projectIsExpanded: props.expandedProjects.indexOf(project.id) >= 0,
                    toggleExpandProject: props.toggleExpandProject.bind(self, project.id),
                    sortObj: props.sortObj,
                    depth: props.depth + 1,
                }));
            });
            if (childProjectElems.length) hasRenderedChildProjects = true;
        }
        
        if (!props.filterActive && !sortedChildFolders.length && !projsInFolder.length) {
            childProjectElems.push(<DashboardListItemEmpty key="empty" />);
        }
    }

    if (
        props.filterActive
        && !folderMatchesFilter
        && !hasRenderedChildFolders
        && !hasRenderedChildProjects
    ) {
        return [];
    }

    return [rootElem].concat(childFolderElems).concat(childProjectElems);
}